/* SIERRA ECHO – flygplatssök på samlingssidor. Filtrerar produktkorten i sidan direkt; Enter söker i hela butiken. */
(function () {
  function norm(s) {
    return (s || '').toString().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  }
  function init(root) {
    var input = root.querySelector('[data-se-finder-input]');
    if (!input) return;
    var empty = root.querySelector('[data-se-finder-empty]');
    var count = root.querySelector('[data-se-finder-count]');
    var searchUrl = root.getAttribute('data-search-url') || '/search';
    var chipBox = root.querySelector('.se-tools__chips');
    var chipOn = root.querySelector('.se-chip.is-active');
    if (chipBox && chipOn && chipBox.scrollWidth > chipBox.clientWidth) {
      chipBox.scrollLeft = chipOn.getBoundingClientRect().left - chipBox.getBoundingClientRect().left + chipBox.scrollLeft - 16;
    }
    var timer;
    function apply() {
      var q = norm(input.value).trim();
      var items = document.querySelectorAll('#product-grid .grid__item');
      var shown = 0;
      items.forEach(function (li) {
        var hit = !q || norm(li.textContent).indexOf(q) !== -1;
        li.classList.toggle('se-hidden', !hit);
        if (hit) shown++;
      });
      if (count) count.textContent = q ? shown + ' av ' + items.length : '';
      if (empty) empty.hidden = !(q && shown === 0);
    }
    input.addEventListener('input', apply);
    input.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      var v = input.value.trim();
      if (!v) return;
      e.preventDefault();
      window.location.href = searchUrl + (searchUrl.indexOf('?') === -1 ? '?' : '&') + 'type=product&q=' + encodeURIComponent(v);
    });
    var cont = document.getElementById('ProductGridContainer');
    if (cont && 'MutationObserver' in window) {
      new MutationObserver(function () {
        clearTimeout(timer);
        timer = setTimeout(apply, 60);
      }).observe(cont, { childList: true, subtree: true });
    }
  }
  document.querySelectorAll('[data-se-finder]').forEach(init);
})();
